<ng-container *ngIf="grouped">
  <li
    *ngIf="grouped.private"
    class="product-detail__favorites-group product-detail__favorites-group--private"
  >
    <h6>{{ 'productDetail.favorites.private.title' | cxTranslate }}</h6>
    <ul>
      <li
        *ngFor="let favorites of grouped.private"
        class="product-detail__favorites"
        [attr.data-cy]="'custom-fav-list-' + favorites.name"
        [ngClass]="{
          'product-detail__favorites-contains-product': favorites.containsProduct
        }"
        (click)="toggleProductInFavorites(favorites)"
      >
        <em class="fas fa-star"></em><span>{{ favorites.name }}</span>
      </li>
    </ul>
  </li>
  <li
    *ngIf="grouped.shared"
    class="product-detail__favorites-group product-detail__favorites-group--shared"
  >
    <h6>{{ 'productDetail.favorites.shared.title' | cxTranslate }}</h6>
    <ul>
      <li
        *ngFor="let favorites of grouped.shared"
        class="product-detail__favorites"
        [ngClass]="{
          'product-detail__favorites-contains-product': favorites.containsProduct
        }"
        (click)="toggleProductInFavorites(favorites)"
      >
        <em class="fas fa-star"></em><span>{{ favorites.name }}</span>
      </li>
    </ul>
  </li>
</ng-container>
<li
  class="product-detail__favorites-add-new"
  data-cy="add-new-fav-list"
  (click)="addProductToNewFavorites()"
>
  <em class="fas fa-plus"></em><span>{{ 'productDetail.favorites.addToNew' | cxTranslate }}</span>
</li>
